import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {useServicesFactoryStore}  from '@/store/services-factory-store';
import { onMounted, onUnmounted } from 'vue';
import MainAplicationContent from './views/platforms/MainAplicationContent.vue';
import { ISesionApp } from './model/ISesionApp';
import {useMainStore} from '@/store/main-store';
import { traduceTexto } from './services/ui/GlobalFunctions';

import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';

import DynamicDialog from 'primevue/dynamicdialog';
import {IAppSystemSettings} from '@/model/IAppSystemSettings';
import { useI18n } from 'vue-i18n';
import moment from 'moment';
import { usePrimeVue } from "primevue/config";
import jsonLangEsDefault from '@/locales/es.json';
import jsonLangEnDefault from '@/locales/en.json'; 
import {eSettingsNames, eThemesNames} from '@/model/GloblasEnum';
import AppSystemSettingsService from "@/services/AppSystemSettingsService";





export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

/**
 * En este componente solo falta validar que la inicializacion o creacion de la
 * base de datos se realice correctamente solo para desk y app para web no se usa db.
 */
const currentLang = useI18n();
const primevue = usePrimeVue();
const mainStore = useMainStore(); 
const uiManager = useServicesFactoryStore().getUIManager;
uiManager.startUiServices();
uiManager.setGlobalLabel('espere',traduceTexto('globals.espere'));
uiManager.setGlobalLabel('cancel',traduceTexto('globals.cancel'));
uiManager.setGlobalLabel('aceptar',traduceTexto('globals.aceptar'));
uiManager.setGlobalLabel('appOptionsComponent',traduceTexto('globals.appOptionsComponent'));
const dbService = useServicesFactoryStore().getDBService;
const loginService = useServicesFactoryStore().getLoginService;
const appSettingsService:AppSystemSettingsService = useServicesFactoryStore().getAppSystemSettings
const storageToPinia = async () =>
{  
  const sesion:ISesionApp|null = await loginService.getSession();    
  if(sesion && sesion.User && sesion.SyncData)
  {
    mainStore.setSesionApp(sesion);
    loginService.VerifyEmpresa(mainStore,sesion.SyncData);    
  }
  await loadSettingsFromDB();
}
const loadSettingsFromDB = async ()=>
{
  const appSettings:IAppSystemSettings[] = await appSettingsService.LoadAppSettings();  
  if(appSettings)
  {
    mainStore.setAppSettings(appSettings);
    const settingLang = appSettingsService.getSettingByName(eSettingsNames.language);    
    const settingTheme = appSettingsService.getSettingByName(eSettingsNames.theme);
    if(settingLang.Value)
    {
      changeLanguage(settingLang.Value);
      useMainStore().setAppLanguage(settingLang.Value);
    }
    if(settingTheme)
      changeTheme(settingTheme);
  } 
}
const changeTheme= (theme:IAppSystemSettings) => 
{
  const themeData = theme.Value.split('_')[0].toLowerCase();  
  if (!themeData || themeData === "light")
  {
    document.documentElement.setAttribute('data-theme', '');
    primevue.changeTheme('lara-dark-purple','lara-light-indigo', 'site-theme-link');    
  }
  else
  {
    document.documentElement.setAttribute('data-theme', eThemesNames.dark);
    primevue.changeTheme('lara-light-indigo','lara-dark-purple', 'site-theme-link');
  }  
}
const changeLanguage = (idioma:any)=>
{  
  //$i18n.locale = idioma.id;
  //https://vue-i18n.intlify.dev/guide/essentials/scope.html
  currentLang.locale.value = idioma;
  moment.locale(idioma);  
  switch(idioma)
  {
    case 'es-mx':
      primevue.config.locale = {...jsonLangEsDefault.prime};
      break;
    case 'en-us': 
      primevue.config.locale = {...jsonLangEnDefault.prime};
      break;
  }  
}
onMounted(async ()=>
{        
  await dbService.Init();
  await storageToPinia();  



});
onUnmounted(async() =>
{
  await dbService.Close();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MainAplicationContent),
    _createVNode(_unref(Toast)),
    _createVNode(_unref(ConfirmDialog)),
    _createVNode(_unref(DynamicDialog))
  ], 64))
}
}

})